import { useAppSelector } from '~/behaviors/redux';
import { uiSelectors } from '~/behaviors/selectors/ui.selectors';
import { CurrentPageState } from '~/behaviors/reducers/ui/currentPage.ui';

export const useGetCurrentPageData = () => {
  const currentPageUI: CurrentPageState = useAppSelector(uiSelectors.selectCurrentPageUI());
  return currentPageUI;
};
